<script setup lang="ts">
import { useHashTab } from "@/vf/components/hash-tab/useHashTab"

defineOptions({ inheritAttrs: false })
defineProps<{ tab: string; unstyled?: boolean }>()
const { activeTab, selectTab } = useHashTab()!
</script>

<template>
    <template v-if="!unstyled">
        <div class="varsity-tab-item" v-bind="$attrs" :class="[{ active: activeTab === tab }]">
            <a href="#" class="varsity-tab-link" @click.prevent="selectTab(tab)">
                <span>
                    <slot v-bind="{ active: activeTab === tab }" />
                </span>
            </a>
        </div>
    </template>
    <template v-if="unstyled">
        <a href="#" v-bind="$attrs" @click.prevent="selectTab(tab)">
            <slot v-bind="{ active: activeTab === tab }" />
        </a>
    </template>
</template>
